import _ from 'lodash';
import React from 'react';
import { components } from '../components';
import { hooks } from "../hooks";
import CustomizeItem from '../items/CustomizeItem';
import { Routes, TabScreens } from '../routes';
import { actions } from '../store/actions';
import { addToCart, updateToCart } from '../store/slices/cartSlice';
import { CartType } from '../types';

export const CustomizeItemForItemOnly: React.FC = () => {
    const navigate = hooks.useNavigate();
    const dispatch = hooks.useDispatch();
    const location = hooks.useLocation();
    hooks.useScrollToTop();

    const cartItem: CartType = location?.state?.categoryItem;
    const isMandatory: boolean = location?.state?.isMandatory;
    const showSkip: any = location?.state?.showSkip;
    const isUpdateCart: any = location?.state?.isUpdateCart;

    if (!cartItem) {
        return <div>Loading item...</div>;
    }

    const onApply = (selectedCustomizations: any[], totalPrice: number) => {
        const selectedItem = _.filter(selectedCustomizations, (item) => item.modCodeId !== -1);
        const item = {
            ...cartItem,
            totalCutomizedItemPrice: totalPrice,
            customizations: selectedItem,
        };
        if (isUpdateCart) {
            dispatch(updateToCart(item));
        } else {
            dispatch(addToCart(item));
        }
        dispatch(actions.setScreen(TabScreens.Order));
        navigate(Routes.TabNavigator, { state: { isMandatory: isMandatory ? isMandatory : false } });
    };

    const onSkipClick = () => {
        dispatch(actions.setScreen(TabScreens.Order));
        navigate(Routes.TabNavigator);
    }

    const renderContent = (): JSX.Element => {
        return (
            <CustomizeItem
                customizeItems={cartItem.allCustomizations ?? []}
                selectedCustomizations={cartItem.customizations ?? []}
                freeModifiers={cartItem.freeModifiers}
                onApply={onApply}
                isMandatory={isMandatory}
                isUpdateCart={isUpdateCart}
            />
        );
    };

    const renderHeader = (): JSX.Element => {
        return (
            <components.Header
                title={cartItem.name}
                showGoBack={isMandatory ? false : true}
                siteRender={false}
                showBasket={false}
                showSkip={showSkip ? true : false}
                onSkipClick={onSkipClick}
                leftLogo={isMandatory ? true : false}
            />
        );
    };

    return (
        <>
            {renderHeader()}
            {renderContent()}
        </>
    );
}
